import React from 'react'
import { List } from 'framework7-react'

import './Form.scss'

export default ({ children, style }) => (
  <List className="form" >
    <form style={style}>{children}</form>
  </List>
)
